export const REPORTING_QUERY_KEYS = {
  answerRate: 'reporting-answerRate',
  numberComparison: 'reporting-numberComparison',
  extensionComparison: 'reporting-extensionComparison',
  extensionLines: 'reporting-extensionLines',
  phoneNumbers: 'reporting-phoneNumbers',
  systemSettings: 'reporting-systemSettings',
} as const
